// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3zhyI","additionalInfo":"AgreementModal_additionalInfo__2UIQ8"};